import { getBaseUrl } from 'helpers/url';

const images = [];

const fonts = [
    { font: "Franchise", path: `${getBaseUrl()}/fonts/BebasNeue-Regular.ttf` },
    { font: "BarlowSemi", path: `${getBaseUrl()}/fonts/futura-pt-book.ttf` },
    { font: "Monstro Solid", path: `${getBaseUrl()}/fonts/Monstro-Solid.otf` },
];

export default {
    images,
    fonts
};
